module.exports = __webpack_public_path__ + "img/owngoal.345fcf4d.png";